import { type GroupManagementNamespace } from '../en-US/groupManagement';

export const groupManagement = {
  apply: 'APLICAR',
  cancel: 'CANCELAR',
  choose_your_community_groups: 'Elige tus grupos comunitarios',
  manage_community_groups: 'Administrar grupos comunitarios',
  manage_details: 'Selecciona los grupos que te interesen de las opciones a continuación.',
  manage_my_groups: 'Administrar mis grupos',
  onboarding_details: '<strong>¡Gracias!</strong> Antes de comenzar, elige los grupos a los que te gustaría unirte. Puedes actualizar tus selecciones en cualquier momento visitando <strong>Administrar mis grupos</strong> en la barra lateral de PrayerStream.',
  skip_for_now: 'OMITIR POR AHORA',
} as const satisfies GroupManagementNamespace;
